import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RentalStatusIconComponent } from './components/rental-status-icon/rental-status-icon.component'
import { UtilityLibraryModule } from '@tokeet-frontend/utility'

@NgModule({
  imports: [CommonModule, MatTooltipModule, UtilityLibraryModule],
  declarations: [RentalStatusIconComponent],
  providers: [],
  exports: [RentalStatusIconComponent],
})
export class RentalsLibraryModule {}
